<template>
  <div class="form-dialog">
    <div class="form-body-scroll-form-contact">
      <div
        class="form-text-title"
        style="position: relative;"
      >
        <div
          class="hide-icon-new"
          @click="_cancelClick"
        >
          <!-- <label
            for="angleDown"
            class="label-hover"
          >
            <v-icon
              name="angle-down"
              scale="1"
              class="icon-padding"
            />
          </label>-->
        </div>
      </div>
      <div class="form-text-title-h1-contact padding-title-contact">
        CONTACTO
      </div>
      <div class="form-box-body-form-contact">
        <vuescroll>
          <div class="form-components scroll">
            <div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>Nombre
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': usuarioNombre }"
              >
                <input
                  id="username"
                  ref="username"
                  v-model="usuarioNombre"
                  class="form__field-input"
                  :class="{ 'form__field-input--filled': usuarioNombre }"
                  autocomplete="off"
                  type="text"
                  name="username"
                  placeholder="Nombre"
                  required
                  maxlength="50"
                  @keypress="keyPressCheckSpecialChars($event, 'name')"
                  @keyup.enter="focusTo('mail')"
                >
              </div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>Correo electrónico
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': usuarioEmail }"
              >
                <input
                  id="mail"
                  ref="mail"
                  v-model="usuarioEmail"
                  class="form__field-input"
                  :class="{ 'form__field-input--filled': usuarioEmail }"
                  autocomplete="off"
                  type="text"
                  name="mail"
                  maxlength="50"
                  value
                  placeholder="Email"
                  required
                  @keypress="keyPressCheckSpecialChars($event, 'email')"
                  @keyup.enter="focusTo('telefono')"
                >
              </div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>Teléfono
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': usuarioTelefono }"
              >
                <input
                  id="telefono"
                  ref="telefono"
                  v-model="usuarioTelefono"
                  class="form__field-input"
                  :class="{ 'form__field-input--filled': usuarioTelefono }"
                  autocomplete="off"
                  type="text"
                  name="telefono"
                  value=""
                  placeholder="xx 1234 5678"
                  maxlength="20"
                  required
                  @keypress="keyPressCheckSpecialChars($event, 'phone')"
                  @change="cleanSpecialChars('telefono', 'phone')"
                  @keyup.enter="_sentClick"
                >
              </div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>Motivo de contacto
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': motivoContacto }"
              >
                <!--<input
                  id="motivo"
                  ref="motivo"
                  v-model="motivoContacto"
                  class="form__field-input"
                  :class="{ 'form__field-input--filled': motivoContacto }"
                  autocomplete="off"
                  type="text"
                  name="motivo"

                  value=""
                  placeholder="Ingresa motivo"
                  maxlength="50"
                  required
                  @keypress="keyPressCheckSpecialChars($event, 'comment')"
                  @change="cleanSpecialChars('motivo', 'comment')"
                  @keyup.enter="focusTo('pais')"
                >-->
                <select
                  id="motivo"
                  ref="motivo"
                  v-model="motivoContacto"
                  name="motivo"
                  class="formulario_combo"
                  :class="{ 'form__field-input--filled': motivoContacto }"
                  autocomplete="off"
                  required
                  @keyup.enter="focusTo('pais')"
                >
                  <!-- Opción predeterminada de selección -->
                  <option
                    disabled
                    value=""
                  >
                    Selecciona ...
                  </option>

                  <!-- Iterar sobre las categorías -->
                  <optgroup
                    v-for="category in categories"
                    :key="category.name"
                    :label="category.name"
                  >
                    <!-- Iterar sobre las opciones de cada categoría -->
                    <option
                      v-for="option in category.options"
                      :key="option.value"
                      :value="option.value"
                    >
                      {{ option.text }}
                    </option>
                  </optgroup>
                </select>
              </div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>País
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': usuarioPais }"
              >
                <input
                  id="pais"
                  ref="pais"
                  v-model="usuarioPais"
                  class="form__field-input"
                  :class="{ 'form__field-input--filled': usuarioPais }"
                  autocomplete="off"
                  type="text"
                  name="pais"
                  value=""
                  placeholder="Ingresa país"
                  maxlength="50"
                  required
                  @keypress="keyPressCheckSpecialChars($event, 'paises')"
                  @change="cleanSpecialChars('pais', 'paises')"
                  @keyup.enter="_sentClick"
                >
              </div>
              <div
                class="form_label"
              >
                Organización
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': usuarioOrganizacion }"
              >
                <input
                  id="Organizacion"
                  ref="Organizacion"
                  v-model="usuarioOrganizacion"
                  class="form__field-input"
                  :class="{ 'form__field-input--filled': usuarioOrganizacion }"
                  autocomplete="off"
                  type="text"
                  name="Organizacion"
                  value=""
                  placeholder="Ingresa organización"
                  maxlength="50"
                  required
                  @keypress="keyPressCheckSpecialChars($event, 'comment')"
                  @change="cleanSpecialChars('Organizacion', 'comment')"
                >
              </div>
              <div
                class="form_label"
              >
                <div class="requered_text">
                  *
                </div>Cuéntanos acerca de tu consulta,<br>duda o sugerencia
              </div>
              <div
                class="form__field"
                :class="{ 'form__field--filled': comentario }"
              >
                <textarea
                  ref="comentario"
                  v-model="comentario"
                  :class="{ 'form__field-textarea--filled': comentario }"
                  style="white-space: pre-line"
                  placeholder="Escribe tu solicitud..."
                  maxlength="200"
                />
              </div>
              <vue-recaptcha
                :sitekey="recaptchaSiteKey"
                :load-recaptcha-script="true"
                class="g-recaptcha custom-recaptcha"
              />
            </div>
          </div>
        </vuescroll>
      </div>
      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          ACEPTAR
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>
import { serverUI } from '../../main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/shipping-fast'
import formUtils from '../../formUtils'
import utils from '../../utils'
import VueRecaptcha from 'vue-recaptcha'

export default {
  components: {
    'v-icon': Icon,
    VueRecaptcha
  },
  props: {},
  methods: {
    ...formUtils.formBase,
    _sentClick () {
      this.errormsg = ''
      if (!this.usuarioNombre || this.usuarioNombre === 'Visita' || this.usuarioNombre === '') {
        this.errormsg = 'Debes ingresar tu nombre'
        this.$refs.username.focus()
        return
      }
      /* if (!this.telefono) {
        this.errormsg = 'Debes ingresar el teléfono'
        return
      } */
      if (!this.usuarioEmail) {
        this.errormsg = 'Debes ingresar un correo'
        this.$refs.mail.focus()
        return
      }
      if (!utils.isEmail(this.usuarioEmail)) {
        this.errormsg = 'Formato de correo incorrecto'
        this.$refs.mail.focus()
        return
      }
      if (!this.usuarioTelefono && this.usuarioTelefono.length <= 8) {
        this.errormsg = 'Debes ingresar teléfono válido'
        this.$refs.telefono.focus()
        return
      }
      if (!this.motivoContacto) {
        this.errormsg = 'Debes ingresar un motivo'
        this.$refs.motivo.focus()
        return
      }
      if (!this.usuarioPais) {
        this.errormsg = 'Debes ingresar tu país'
        this.$refs.pais.focus()
        return
      }

      if (!this.comentario || this.comentario.length < 5) {
        this.errormsg = 'Debes ingresar tu solicitud'
        this.$refs.comentario.focus()
        return
      }

      const responseCaptcha = window.grecaptcha.getResponse()
      if (responseCaptcha.length === 0) {
        this.errormsg = 'Debes validar que no eres un robot.'
        return
      }
      const dataToSend = {
        form: 'BsxContactForm',
        evento: 'sentClick',
        data: {
          type: 'bsx-contact-form-confirm',
          fields: {
            nombre: this.usuarioNombre,
            telefono: this.usuarioTelefono,
            email: this.usuarioEmail,
            motivo: this.motivoContacto,
            pais: this.usuarioPais,
            organizacion: this.usuarioOrganizacion,
            comentario: this.comentario
          }
        }
      }

      serverUI.$emit('FormEvent', dataToSend)
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'BsxContactForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    },
    onRecaptchaVerified (response) {
      console.log('reCAPTCHA verificado, respuesta:', response)
      // Puedes enviar la respuesta al backend aquí
    },
    onRecaptchaVerified2 () {
      const response = window.grecaptcha.getResponse()
      if (response.length === 0) {
        this.errormsg = 'Debes validar si no eres un robot.'
      } else {
        // Manejar la respuesta del reCAPTCHA aquí
        console.log('reCAPTCHA response:', response)
      }
    }

  },
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      usuarioNombre: '',
      usuarioEmail: '',
      usuarioTelefono: '',
      motivoContacto: '',
      usuarioPais: '',
      usuarioOrganizacion: '',
      comentario: '',
      recaptchaSiteKey: '6LdU4B0cAAAAAB0G1szbopLIG6BWUc1_O2Occm8l',
      categories: [
        {
          name: 'Servicio al Cliente',
          options: [
            { value: 'acciones', text: 'Acciones' },
            { value: 'acceso_usuarios', text: 'Acceso Usuarios' },
            { value: 'boletin', text: 'Boletín' },
            { value: 'certificados', text: 'Certificados' },
            { value: 'como_invertir', text: 'Cómo Invertir' },
            { value: 'estructura_bolsa', text: 'Estructura de la Bolsa' },
            { value: 'horarios_atencion', text: 'Horarios de Atención' },
            { value: 'indices_burstastiles', text: 'Índices Burstátiles' },
            { value: 'inscripciones_bolsa', text: 'Inscripciones Bolsa de Valores' },
            { value: 'pago_dividendos', text: 'Pago de Dividendos' },
            { value: 'problemas_web', text: 'Problemas en la Página Web' },
            { value: 'resena_historica', text: 'Reseña Histórica' }
          ]
        },
        {
          name: 'Negocios',
          options: [
            { value: 'cotizaciones', text: 'Cotizaciones' },
            { value: 'informacion_tecnologica', text: 'Información de Soluciones Tecnológicas' },
            { value: 'brain_data', text: 'Brain Data' }
          ]
        },
        {
          name: 'Tienda Online',
          options: [
            { value: 'bases_datos', text: 'Bases de Datos' },
            { value: 'suscripciones', text: 'Suscripciones' }
          ]
        },
        {
          name: 'Cursos Círculo de Educación Financiera',
          options: [
            { value: 'cursos_circulo', text: 'Cursos Círculo de Educación Financiera' }
          ]
        },
        {
          name: 'CCI',
          options: [
            { value: 'borrar_cuenta', text: 'Borrar Cuenta' },
            { value: 'info_concurso', text: 'Información sobre el Concurso' },
            { value: 'inscripciones_concurso', text: 'Inscripciones al Concurso' }
          ]
        },
        {
          name: 'Visitas In & Out',
          options: [
            { value: 'visitas_in_out', text: 'Visitas In & Out' }
          ]
        },
        {
          name: 'Hazte Partner',
          options: [
            { value: 'hazte_partner', text: 'Hazte Partner' }
          ]
        },
        {
          name: 'Prensa',
          options: [
            { value: 'prensa', text: 'Prensa' }
          ]
        },
        {
          name: 'Sugerencias, Felicitaciones o Reclamos',
          options: [
            { value: 'sugerencias', text: 'Sugerencias' },
            { value: 'felicitaciones', text: 'Felicitaciones' },
            { value: 'reclamos', text: 'Reclamos' }
          ]
        },
        {
          name: 'Proveedores',
          options: [
            { value: 'proveedores', text: 'Proveedores' }
          ]
        },
        {
          name: 'Otro Motivo',
          options: [
            { value: 'otro_motivo', text: 'Otro motivo' }
          ]
        }
      ]
    }
  },
  computed: {},
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'BsxContactForm') return
      if (e.evento === 'newdata') {
        this.title = e.dato.title ? e.dato.title : 'CONTACTO'
        this.text = e.dato.text ? e.dato.text : ''
        this.title = e.dato.title ? e.dato.title : 'CONTACTO'
        this.text = e.dato.text ? e.dato.text : ''
        this.nombreOrigen = e.dato.fields.name ? e.dato.fields.name : ''
        this.emailOrigen = e.dato.fields.email ? e.dato.fields.email : ''
        this.telefonoOrigen = e.dato.fields.phone
          ? e.dato.fields.phone
          : ''
        this.usuarioNombre = this.nombreOrigen
        this.usuarioEmail = this.emailOrigen
        this.usuarioTelefono = this.telefonoOrigen
      }
    })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
.form__field {
	margin-bottom: 7px;
}

.form-box-body {
	height: 370px;
}
</style>
